// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"310":"exam","594":"about"}[chunkId] + "." + {"310":"f691b89c","594":"1f414c07"}[chunkId] + ".css";
};